import React from 'react';

interface ISecondaryButton {
  label: string;
  disabled?: boolean;
  Icon?: React.ComponentType<{}>;
  width?: string;
  height?: string;
  text?: string;
  onClick: () => void;
}
const DarkButton: React.FC<ISecondaryButton> = ({
  label = '',
  disabled = false,
  Icon,
  width = '',
  height = '',
  text = '',
  onClick = () => {},
}) => {
  return (
    <div
      className={`flex items-center cursor-pointer rounded-1 text-white px-4 py-2 bg-black2 ${
        height ? height : 'h-[36px]'
      } ${width ? width : 'w-fit'} gap-x-2 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}
      onClick={onClick}
    >
      {Icon ? <Icon /> : <></>}
      <label
        className={`text-white ${
          text ? text : 'text-sm'
        } mx-auto font-medium whitespace-nowrap cursor-pointer`}
      >
        {label}
      </label>
    </div>
  );
};

export default DarkButton;
